
import { useScroll, useTransform, motion } from "motion/react";
import React, { useEffect, useRef, useState } from "react";
import { useStateContext } from "../../context/ContextProvider";
import { timeLineData } from "../../constants";
import { drak_Scroll_Icon, scroll_Icon } from "../../assets/images/timeLine_Images";


export const Timeline = ({
  title,subtitle
}) => {
  const ref = useRef(null);
  const containerRef = useRef(null);
  const [height, setHeight] = useState(0);
const {currentLang,currentMode}=useStateContext()
const isAr=currentLang==="ar"
const isDark=currentMode==="Dark"
  useEffect(() => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect();
      setHeight(rect.height);
    }
  }, [ref]);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 10%", "end 50%"],
  });

  const heightTransform = useTransform(scrollYProgress, [0, 1], [0, height]);
  const opacityTransform = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  return (
    <div
      className="w-full  font-sans md:px-10"
      ref={containerRef}>
      <div className="max-w-7xl mx-auto pb-20 px-4 md:px-8 lg:px-10">
        <h2 className="h3 animated-gradient-text max-w-4xl">
          {title}
        </h2>
        <p
          className="text-light-subtitle h6 dark:text-dark-subtitle max-w-4xl">
        {subtitle}
        </p>
      </div>
      <div ref={ref} className="relative max-w-7xl mx-auto pb-20">
        {timeLineData.items.map((item) => (
         <div key={item.id} className="flex justify-start pb-10 md:pb-40 md:gap-10">
         <div
           className={`sticky flex flex-col md:flex-row z-40 items-center top-40 self-start max-w-xs lg:max-w-sm md:w-full`}>
           <div
             className={`h-10 absolute ${isAr ? "right-3 md:right-3":"left-3 md:left-3"}  w-10 rounded-full bg-light-primary dark:bg-dark-primary flex items-center justify-center`}>
              <img src={isDark ? drak_Scroll_Icon :scroll_Icon} className="w-full h-full " />
           
           </div>
           <h3
             className={`hidden md:block   ${isAr ? "md:pr-20": "md:pl-20"}  `}>
           <span className=" md:text-5xl block font-bold text-neutral-500 dark:text-dark-subtitle text-xl">{item.date}</span>  
             <span className="text-gray-500 dark:text-gray-400 h5">{isAr ? item.title_Ar :item.title_En}</span>
           </h3>
         </div>
     
         <div className={`relative ${isAr ?"pr-20 md:pl:4" : "pl-20 pr-4 md:pl-4 "} w-full`}>
           <h3
             className={`md:hidden block text-2xl mb-4 ${isAr ? "text-right": "text-left"}  font-bold text-neutral-500 dark:text-neutral-500`}>
             {item.date}
           </h3>
           <div>
       <p
         className="body-1 leading-relaxed mb-8 text-light-text  dark:text-dark-text">
         {isAr ?item.description_Ar :item.description_En}
       </p>
       <div className="grid grid-cols-2 gap-4">
         {item.images.map((image,index)=>(
       <img
       src={image}
     key={index}
       width={500}
       height={500}
       className="h-20 w-full rounded-lg object-cover shadow-[0_0_24px_rgba(34,_42,_53,_0.06),_0_1px_1px_rgba(0,_0,_0,_0.05),_0_0_0_1px_rgba(34,_42,_53,_0.04),_0_0_4px_rgba(34,_42,_53,_0.08),_0_16px_68px_rgba(47,_48,_55,_0.05),_0_1px_0_rgba(255,_255,_255,_0.1)_inset] md:h-44 lg:h-60" />
         ))}
        
       </div>
     </div>
         </div>
       </div>
    
        ))}
        <div
          style={{
            height: height + "px",
          }}
          className={`absolute ${isAr ? "md:right-8 right-8" : "md:left-8 left-8 "} top-0 overflow-hidden w-[2px] bg-[linear-gradient(to_bottom,var(--tw-gradient-stops))] from-transparent from-[0%] via-neutral-200 dark:via-neutral-700 to-transparent to-[99%]  [mask-image:linear-gradient(to_bottom,transparent_0%,black_10%,black_90%,transparent_100%)] `}>
          <motion.div
            style={{
              height: heightTransform,
              opacity: opacityTransform,
            }}
            className="absolute inset-x-0 top-0  w-[2px] bg-gradient-to-t from-[#0a2eff]  via-light-blue  to-transparent   from-[0%]  via-[10%]rounded-full" />
        </div>
      </div>
    </div>
  );
};
